import { createApp } from 'vue';
import CompletedHikes from "./CompletedHikes.vue";
import { i18n } from '../../i18n';

function mountCompletedHikesApp(elementId: string) {
  const el = document.getElementById(elementId)
  if (!el) return

  const app = createApp(CompletedHikes)
  app.use(i18n);
  app.mount(`#${elementId}`)
}

if (document.getElementById('completed-hikes-app')) {
  mountCompletedHikesApp('completed-hikes-app')
}
